<template>
  <div id="app">
    <router-view v-if="isRouterAlive"/>
    <ewm ref="ewm"></ewm>
    <AI/>
  </div>
</template>

<script>
  import ewm from "@/views/components/ewm/ewm.vue";
import AI from '@/components/AI/index.vue'

  export default {
    name:  'App',
    components:{ewm,AI},
    provide (){
      return {
        reload: this.reload,
        showEwm:this.toShow
      }
    },
    data(){
      return {
        isRouterAlive:true,

      }
    },
    methods:{
      //页面重新加载
      reload(){
        this.isRouterAlive=false;
        this.$nextTick(function(){
          this.isRouterAlive=true;
        })
      },
      toShow(){
        this.$refs.ewm.show();
      }
    }
  }
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.wh1200 {
  width: 1200px;
  margin: 0 auto;
  position: relative;
}
  
// 图标文字
.icon-large {
    font-size: 24px; /* 或者你想要的任何大小 */
}

.text-large {
    font-size: 20px; /* 或者你想要的任何大小 */
    margin-left: 5px;
}

.text-bold {
    font-weight: bold;
}

// 上传
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
